// Stub. The legacy `/forecasts/predict-next-week` endpoint is also on its
// way out on the backend, so there's nothing to call against in the
// autogenerated client. Returns an empty list to keep the call site wired
// while we figure out what replaces the predict-next-week flow.
async function forecastWeek(_args: {
  tenantId: string;
  zoneId: string;
  date: Time.Day;
}): Promise<Data.Projection[]> {
  return [];
}

export { forecastWeek };
